import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../pages/LandingDaylight.css';

const FOOTER_LINKS = [
    { label: 'Privacy', path: '/privacy' },
    { label: 'Terms', path: '/terms' },
    { label: 'Contact', path: '/contact' },
    { label: 'Suggestions', path: '/suggestions' }
];

interface LandingHeaderProps
{
    onNavigateSection?: (sectionId: string) => void;
    onNavigateHome?: () => void;
}

export function LandingHeader({ onNavigateSection, onNavigateHome }: LandingHeaderProps): React.ReactElement
{
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    function navigateToSection(sectionId: string): void
    {
        if (onNavigateSection)
        {
            onNavigateSection(sectionId);
            return;
        }

        navigate({ pathname: '/', hash: sectionId });
    }

    return (
        <nav className="ll-nav" aria-label="Main navigation">
            <button className="ll-brand" type="button" onClick={() => onNavigateHome ? onNavigateHome() : navigate('/')}>
                <img src="/Accelirate.svg" alt="" />
                <span>Acceli<em>QA</em></span>
            </button>
            <div className="ll-nav-links">
                <button type="button" onClick={() => navigateToSection('ll-features')}>Platform</button>
                <button type="button" onClick={() => navigateToSection('ll-workflow')}>How it works</button>
                <button type="button" onClick={() => navigateToSection('ll-trust')}>Why trust it</button>
            </div>
            <div className="ll-nav-actions">
                {isAuthenticated ? (
                    <button className="ll-btn ll-btn-primary ll-btn-sm" type="button" onClick={() => navigate('/dashboard')}>
                        Dashboard
                    </button>
                ) : (
                    <>
                        <button className="ll-btn ll-btn-ghost ll-btn-sm" type="button" onClick={() => navigate('/login')}>
                            Sign in
                        </button>
                        <button className="ll-btn ll-btn-primary ll-btn-sm" type="button" onClick={() => navigate('/early-access')}>
                            Get early access
                        </button>
                    </>
                )}
            </div>
        </nav>
    );
}

export function LandingFooter(): React.ReactElement
{
    const navigate = useNavigate();

    return (
        <footer className="ll-footer">
            <div className="ll-container ll-footer-inner">
                <div className="ll-footer-brand">
                    <img src="/Accelirate.svg" alt="" />
                    <span>Acceli<em>QA</em></span>
                    <p>© {new Date().getFullYear()} Accelirate Inc. · AI-powered quality engineering.</p>
                </div>
                <div className="ll-footer-links">
                    {FOOTER_LINKS.map((link) => (
                        <button key={link.label} type="button" onClick={() => navigate(link.path)}>
                            {link.label}
                        </button>
                    ))}
                </div>
            </div>
        </footer>
    );
}
